<div class="page-head">
  <div>
    <p class="eyebrow">การเงิน</p>
    <h1>ตรวจสอบใบขอเบิก</h1>
    <p>ตรวจสอบรายการขอเบิกและพิจารณาอนุมัติโดยฝ่ายบัญชี</p>
  </div>
</div>

<section class="rounded-xl border border-slate-200 bg-white shadow-sm">
  <p-table
    #expensesTable
    [value]="expenses()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="[
      'code',
      'bookingCode',
      'title',
      'expenseNameSnapshot',
      'bankName',
      'accountNumber',
      'requester',
      'customerName',
      'tripName',
      'status',
    ]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '1060px' }"
  >
    <ng-template #caption>
      <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <label class="relative block w-full max-w-md">
          <lucide-icon
            name="Search"
            [size]="17"
            class="pointer-events-none absolute top-1/2 left-2 z-10 -translate-y-1/2 text-slate-400"
          />
          <input
            pInputText
            #query
            class="h-11 w-full pr-3 text-sm placeholder:text-slate-400"
            style="padding-left: 2.75rem; border-radius: 0.5rem"
            placeholder="ค้นหาใบขอเบิก Booking รายการ หรือผู้ขอ"
            (input)="expensesTable.filterGlobal(query.value, 'contains')"
          />
        </label>
        <app-refresh-button
          label="รีเฟรชรายการตรวจสอบใบขอเบิก"
          [loading]="isLoadingExpenses()"
          (refresh)="loadExpenses()"
        />
        <!-- <p class="m-0 text-xs text-slate-500">
          รอตรวจสอบทั้งหมด
          <span class="font-semibold text-slate-700">{{ expenses().length }}</span>
          รายการ
        </p> -->
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th class="w-14 text-center text-xs whitespace-nowrap">ลำดับ</th>
        <th pSortableColumn="code" class="min-w-56 text-xs whitespace-nowrap">
          ใบขอเบิก <p-sortIcon field="code" />
        </th>
        <th pSortableColumn="bookingCode" class="min-w-72 text-xs whitespace-nowrap">
          ทัวร์ / Booking และรายละเอียด <p-sortIcon field="bookingCode" />
        </th>
        <th pSortableColumn="requester" class="min-w-48 text-xs whitespace-nowrap">
          ผู้ขอเบิก <p-sortIcon field="requester" />
        </th>
        <th pSortableColumn="amount" class="w-44 text-right text-xs whitespace-nowrap">
          จำนวนเงิน <p-sortIcon field="amount" />
        </th>
        <th pSortableColumn="status" class="w-52 text-xs whitespace-nowrap">
          สถานะ <p-sortIcon field="status" />
        </th>
        <th class="w-36 text-right text-xs whitespace-nowrap">ดำเนินการ</th>
      </tr>
    </ng-template>
    <ng-template #body let-row let-rowIndex="rowIndex">
      <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/60">
        <td class="py-3.5 text-center text-[13px] text-slate-400 tabular-nums align-top">
          {{ rowIndex + 1 }}
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">{{ row.code }}</p>
          <p class="mt-1 mb-0 text-xs leading-5 text-slate-500">
            {{ row.expenseNameSnapshot || 'ไม่ระบุประเภทค่าใช้จ่าย' }}
          </p>
          <p class="mt-1 mb-0 text-xs whitespace-nowrap text-slate-500">
            ส่งเมื่อ {{ row.submittedAt | date: 'dd MMM yyyy' }}
          </p>
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800">
            {{ row.tourDetails?.tourNo || row.bookingCode || '—' }}
          </p>
          <p class="mt-1 mb-0 max-w-72 text-xs leading-5 text-slate-500">
            {{ row.title || 'ไม่ระบุรายละเอียด' }}
          </p>
          @if (row.targetType !== 'GENERAL' && row.paymentAccountSource) {
            <p class="mt-1 mb-0 max-w-72 text-xs leading-5 text-sky-700">
              บัญชีรับเงิน:
              @if (row.paymentAccountSource === 'OTHER_BANK_ACCOUNT') {
                {{ row.bankName || 'ไม่ระบุธนาคาร' }} · {{ row.accountNumber || 'ไม่ระบุเลขบัญชี' }}
              } @else {
                ตามไฟล์อ้างอิง
              }
            </p>
          }
          @if (row.targetType !== 'GENERAL') {
            <p class="mt-1 mb-0 text-xs text-slate-500">ลูกค้า: {{ row.customerName || '—' }}</p>
          }
        </td>
        <td class="py-3.5 text-[13px] align-top">
          <p class="m-0 text-sm font-medium leading-5 text-slate-800">
            {{ row.requester || '—' }}
          </p>
          <p class="mt-1 mb-0 max-w-48 text-xs leading-5 text-slate-500">
            {{ row.tripName || 'ไม่ระบุโปรแกรมทัวร์' }}
          </p>
        </td>
        <td
          class="py-3.5 text-right text-sm font-semibold whitespace-nowrap text-slate-800 tabular-nums align-top"
        >
          {{ row.amount | number: '1.2-2' }} บาท
        </td>
        <td class="py-3.5 align-top">
          <app-status-badge [status]="row.status" />
        </td>
        <td class="py-3.5 align-top">
          <div class="flex justify-end gap-1.5">
            @if (row.attachmentUrl) {
              <button
                type="button"
                class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white p-0 text-slate-600 hover:bg-slate-50"
                title="เปิดไฟล์ใบสั่งซื้อ"
                (click)="openAttachment(row.attachmentUrl)"
              >
                <lucide-icon name="FileText" [size]="15" />
              </button>
            }

            <button
              type="button"
              class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white p-0 text-slate-600 hover:bg-slate-50"
              title="ดูรายละเอียด"
              (click)="openExpenseDetail(row)"
            >
              <lucide-icon name="Eye" [size]="15" />
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="7">
          <div class="empty">
            <h3>ไม่พบใบขอเบิก</h3>
            <p>ลองเปลี่ยนคำค้นหา</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

@if (selectedExpense(); as expense) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closeExpenseDetail()"
  >
    <section
      class="my-auto w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="expense-detail-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            {{ expense.code }}
          </p>
          <h2 id="expense-detail-title" class="m-0 text-xl font-bold text-slate-800">
            รายละเอียดใบขอเบิก
          </h2>
          <div class="mt-2"><app-status-badge [status]="expense.status" /></div>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          aria-label="ปิดหน้าต่าง"
          (click)="closeExpenseDetail()"
        >
          <lucide-icon name="X" [size]="19" />
        </button>
      </div>

      <div class="max-h-[68vh] overflow-y-auto p-5 sm:p-6">
        @if (expense.tourDetails; as tour) {
          <section>
            <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลทัวร์</h3>
            <dl
              class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
            >
              <div>
                <dt class="text-xs font-semibold text-slate-500">เลขที่ทัวร์</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourNo }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">รหัสทัวร์</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourCode }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ชื่อทัวร์</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.tourName }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ประเทศ</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ tour.country || '—' }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">วันเดินทาง</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ tour.travelDate | date: 'dd MMM yyyy' }}
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">วันเดินทางกลับ</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ tour.returnDate ? (tour.returnDate | date: 'dd MMM yyyy') : '—' }}
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">จำนวนคนที่กำหนด</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ tour.requiredPax === null ? '—' : tour.requiredPax + ' คน' }}
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ยอดรวมทัวร์</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ (tour.tourTotalAmount | number: '1.2-2') + ' บาท' }}
                </dd>
              </div>
            </dl>
          </section>
        } @else if (expense.bookingCode) {
          <section>
            <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูล Booking</h3>
            <dl
              class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
            >
              <div>
                <dt class="text-xs font-semibold text-slate-500">เลขที่ Booking</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.bookingCode }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ลูกค้า</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.customerName }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">โปรแกรมทัวร์</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.tripName }}</dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">วันเดินทาง</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ expense.travelDate | date: 'dd MMM yyyy' }}
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">จำนวนผู้เดินทาง</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ expense.travelerCount | number }} คน
                </dd>
              </div>
              <div>
                <dt class="text-xs font-semibold text-slate-500">ยอด Booking</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  {{ expense.bookingTotal | number: '1.2-2' }} บาท
                </dd>
              </div>
            </dl>
          </section>
        }
        <section [class.mt-6]="!!expense.tourDetails || !!expense.bookingCode">
          <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลรายการเบิก</h3>
          <dl
            class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
          >
            <div>
              <dt class="text-xs font-semibold text-slate-500">เลขที่ใบขอเบิก</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.code }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ผู้ขอเบิก</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.requester }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">ประเภทค่าใช้จ่าย</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ expense.expenseNameSnapshot }}
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">รายการ</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ expense.title }}</dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">วันที่ส่งเบิก</dt>
              <dd class="mt-1 mb-0 font-semibold text-slate-800">
                {{ expense.submittedAt | date: 'dd MMM yyyy' }}
              </dd>
            </div>
            <div>
              <dt class="text-xs font-semibold text-slate-500">จำนวนเงิน</dt>
              <dd class="mt-1 mb-0 font-semibold text-emerald-700">
                {{ expense.amount | number: '1.2-2' }} บาท
              </dd>
            </div>

            @if (expense.paymentAccountSource) {
              <div class="sm:col-span-2 lg:col-span-3">
                <dt class="text-xs font-semibold text-slate-500">ข้อมูลบัญชีรับเงิน</dt>
                <dd class="mt-1 mb-0 font-semibold text-slate-800">
                  @if (expense.paymentAccountSource === 'OTHER_BANK_ACCOUNT') {
                    {{ expense.bankName || 'ไม่ระบุธนาคาร' }} ·
                    {{ expense.accountNumber || 'ไม่ระบุเลขที่บัญชี' }}
                  } @else {
                    ตามไฟล์อ้างอิง
                  }
                </dd>
              </div>
            }

            <div>
              <dt class="text-xs font-semibold text-slate-500">ไฟล์ใบสั่งซื้อ</dt>
              <dd class="mt-1 mb-0 break-all font-semibold text-sky-700">
                @if (expense.attachmentUrl) {
                  <button
                    type="button"
                    class="inline-flex items-center gap-1.5 text-sky-700 decoration-sky-300 hover:text-sky-900"
                    title="ดูใบสั่งซื้อในแท็บใหม่"
                    (click)="openAttachment(expense.attachmentUrl)"
                  >
                    ดูใบสั่งซื้อ
                    <lucide-icon name="ExternalLink" [size]="15" />
                  </button>
                } @else {
                  <span class="text-slate-400">-</span>
                }
              </dd>
            </div>
            @if (expense.receiptPath) {
              <div>
                <dt class="text-xs font-semibold text-slate-500">ไฟล์ใบเสร็จ</dt>
                <dd class="mt-1 mb-0 break-all font-semibold text-sky-700">
                  @if (expense.receiptPath) {
                    <button
                      type="button"
                      class="inline-flex items-center gap-1.5 text-sky-700 decoration-sky-300 hover:text-sky-900"
                      title="ดูใบเสร็จในแท็บใหม่"
                      (click)="openAttachment(expense.receiptPath)"
                    >
                      ดูใบเสร็จ
                      <lucide-icon name="ExternalLink" [size]="15" />
                    </button>
                  } @else {
                    <span class="text-slate-400">-</span>
                  }
                </dd>
              </div>
            }
          </dl>

          @if (expense.financialAdjustments.length) {
            <section class="mt-6">
              <h3 class="m-0 text-base font-bold text-slate-800">คำขอปรับวงเงินที่เกี่ยวข้อง</h3>
              @for (adjustment of expense.financialAdjustments; track adjustment.id) {
                <article class="mt-4">
                  <dl
                    class="grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-3"
                  >
                    <div>
                      <dt class="text-xs font-semibold text-slate-500">เลขที่คำขอ</dt>
                      <dd class="mt-1 mb-0 font-semibold text-slate-800">{{ adjustment.adjustmentNo }}</dd>
                    </div>
                    <div>
                      <dt class="text-xs font-semibold text-slate-500">สถานะ</dt>
                      <dd class="mt-1 mb-0"><app-status-badge [status]="adjustment.status" /></dd>
                    </div>
                    <div>
                      <dt class="text-xs font-semibold text-slate-500">ประเภทคำขอ</dt>
                      <dd class="mt-1 mb-0 font-semibold text-slate-800">
                        {{ adjustment.targetType === 'TOUR' ? 'คำขอของ Tour' : 'คำขอของ Booking' }}
                      </dd>
                    </div>
                    @if (adjustment.tourPriceDelta > 0) {
                      <div>
                      <dt class="text-xs font-semibold text-slate-500">เพิ่มค่าทัวร์ทั้งหมด</dt>
                      <dd class="mt-1 mb-0 font-semibold text-slate-800">
                        {{ adjustment.tourPriceDelta | number: '1.2-2' }} บาท
                      </dd>
                      </div>
                    }
                    @if (adjustment.expenseBudgetDelta > 0) {
                      <div>
                      <dt class="text-xs font-semibold text-slate-500">เพิ่มวงเงินค่าใช้จ่าย</dt>
                      <dd class="mt-1 mb-0 font-semibold text-slate-800">
                        {{ adjustment.expenseBudgetDelta | number: '1.2-2' }} บาท
                      </dd>
                      </div>
                    }
                    @if (adjustment.customerChargeDelta > 0) {
                      <div>
                      <dt class="text-xs font-semibold text-slate-500">เรียกเก็บลูกค้าเพิ่ม</dt>
                      <dd class="mt-1 mb-0 font-semibold text-slate-800">
                        {{ adjustment.customerChargeDelta | number: '1.2-2' }} บาท
                      </dd>
                      </div>
                    }
                    @if (adjustment.companyAdvanceAmount > 0) {
                      <div>
                      <dt class="text-xs font-semibold text-slate-500">บริษัทสำรองจ่าย</dt>
                      <dd class="mt-1 mb-0 font-semibold text-slate-800">
                        {{ adjustment.companyAdvanceAmount | number: '1.2-2' }} บาท
                      </dd>
                      </div>
                    }
                    @if (adjustment.advanceAttachmentPath) {
                      <div>
                      <dt class="text-xs font-semibold text-slate-500">เอกสารประกอบ</dt>
                      <dd class="mt-1 mb-0">
                        <button
                          type="button"
                          class="inline-flex items-center gap-1.5 font-semibold text-sky-700 decoration-sky-300 hover:text-sky-900"
                          title="ดูเอกสารแนบในแท็บใหม่"
                          (click)="openAttachment(adjustment.advanceAttachmentPath)"
                        >
                          ดูเอกสารแนบ
                          <lucide-icon name="ExternalLink" [size]="15" />
                        </button>
                      </dd>
                      </div>
                    }
                    <div class="sm:col-span-2 lg:col-span-3">
                      <dt class="text-xs font-semibold text-slate-500">เหตุผล</dt>
                      <dd class="mt-1 mb-0 leading-6 text-slate-800">{{ adjustment.reason || '—' }}</dd>
                    </div>
                  </dl>
                </article>
              }
            </section>
          }

          @if (expense.status === 'WAITING_PAYMENT') {
            <section class="mt-6">
              <h3 class="m-0 text-base font-bold text-slate-800">ข้อมูลการจ่ายเงิน</h3>
              <div class="mt-4 grid gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 sm:grid-cols-2">
                <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
                  <span>วันที่โอนเงิน <span class="text-red-500">*</span></span>
                  <p-datepicker
                    class="w-full font-normal"
                    [(ngModel)]="expense.transferDate"
                    (ngModelChange)="clearTransferDateTimeError()"
                    dateFormat="dd/mm/yy"
                    placeholder="เลือกวันที่โอนเงิน"
                    [showIcon]="true"
                    [readonlyInput]="true"
                    appendTo="body"
                  />
                </label>
                <label class="grid content-start gap-1 text-sm font-semibold text-slate-700">
                  <span>เวลาโอนเงิน <span class="text-red-500">*</span></span>
                  <p-datepicker
                    class="w-full font-normal"
                    [(ngModel)]="expense.transferTime"
                    (ngModelChange)="clearTransferDateTimeError()"
                    [timeOnly]="true"
                    hourFormat="24"
                    placeholder="เลือกเวลาโอนเงิน"
                    [showIcon]="true"
                    [readonlyInput]="true"
                    appendTo="body"
                  />
                </label>
                <label class="grid content-start gap-1 text-sm font-semibold text-slate-700 sm:col-span-2">
                  <span>ลิงก์สลิป <span class="text-red-500">*</span></span>
                  <input
                    type="url"
                    pInputText
                    class="h-11 w-full font-normal"
                    [class.p-invalid]="!!receiptUrlError()"
                    [(ngModel)]="expense.receiptUrl"
                    (ngModelChange)="clearReceiptUrlError()"
                    placeholder="https://example.com/payment-slip"
                  />
                  <span class="min-h-4">
                    @if (receiptUrlError()) {
                      <small class="font-normal text-red-600">{{ receiptUrlError() }}</small>
                    }
                  </span>
                </label>
                <div class="sm:col-span-2">
                  <label
                    class="inline-flex cursor-pointer items-center gap-2 text-sm font-semibold text-slate-700"
                    for="expense-has-withholding-tax"
                  >
                    <p-checkbox
                      inputId="expense-has-withholding-tax"
                      [(ngModel)]="expense.hasWithholdingTax"
                      [binary]="true"
                      (onChange)="onWithholdingTaxChange(expense, $event.checked)"
                    />
                    <span>หัก ณ ที่จ่าย</span>
                  </label>

                  @if (expense.hasWithholdingTax) {
                    <label class="mt-3 grid content-start gap-1 text-sm font-semibold text-slate-700">
                      <span>ยอดหัก ณ ที่จ่าย <span class="text-red-500">*</span></span>
                      <p-inputnumber
                        class="w-full font-normal"
                        inputStyleClass="h-11 w-full"
                        [(ngModel)]="expense.withholdingTaxAmount"
                        (ngModelChange)="clearWithholdingTaxError()"
                        mode="currency"
                        currency="THB"
                        locale="th-TH"
                        [min]="0"
                        [max]="expense.amount"
                        [class.p-invalid]="!!withholdingTaxError()"
                        placeholder="0.00"
                      />
                      <span class="min-h-4">
                        @if (withholdingTaxError()) {
                          <small class="font-normal text-red-600">{{ withholdingTaxError() }}</small>
                        }
                      </span>
                    </label>
                  }
                </div>
                @if (transferDateTimeError()) {
                  <small class="sm:col-span-2 font-normal text-red-600">{{ transferDateTimeError() }}</small>
                }
              </div>
            </section>
          }
        </section>
      </div>

      <div
        class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6"
      >
        <button
          type="button"
          class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-[15px] font-semibold text-slate-700 hover:bg-slate-100"
          (click)="closeExpenseDetail()"
        >
          ปิด
        </button>
        @if (
          expense.status === 'WAITING_PAYMENT' || expense.status === 'ACCOUNTING_REVIEW_RECEIPT'
        ) {
          <button
            type="button"
            class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-red-200 bg-white px-5 text-[15px] font-semibold text-red-600 hover:bg-red-50"
            (click)="reject(expense)"
          >
            <lucide-icon name="X" [size]="17" /> ไม่อนุมัติ
          </button>
          <button
            type="button"
            class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-5 text-[15px] font-semibold text-white hover:bg-emerald-700"
            (click)="approve(expense)"
          >
            <lucide-icon name="Check" [size]="17" /> อนุมัติ
          </button>
        }
      </div>
    </section>
  </div>
}
